import axios from "axios";

export const __ExportThirdParties = async (endpoint, token) => {
  const options = {
    method: "GET",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    }
  };

  const res = await axios(`${endpoint}`, options);
  return res;
};
